
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Chip extends Vue {
  @Prop({ type: String, required: false, default: 'purple' }) public background!: string;
  @Prop({ type: String, required: false, default: 'white' }) public color!: string;
  @Prop({ type: String, required: false, default: 'white' }) public circleColor!: string;
  @Prop({ type: String, required: false, default: 'mdi-axis-z-arrow' }) public icon!: string;
  @Prop({ type: String, required: false, default: 'process' }) public text!: string;
  @Prop({ type: Boolean, required: false, default: false }) public disabled!: boolean;
}
